import { StyleSheet } from 'react-native';
import { Size } from 'src/constants';

export const containedStyle = StyleSheet.create({
  button: { alignSelf: 'stretch', borderWidth: 1, padding: Size.S }
});

export default containedStyle;
